import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as routes from '../../constants/routes';
import { getLegalAdvicePage } from '../../redux/actions';
import BaseRoute from './sub_routes/base_route';
import NewRoute from './sub_routes/new_route';
import QuestionRoute from './sub_routes/question_route';
import ResultsRoute from './sub_routes/results_route';
import './index.scss';
import { useGetLegalAdvicePageQuery } from '../../redux/api/relations.api';
import { parseApiResponse } from 'app/functions';
const LegalAdvice = () => {
    const dispatch = useDispatch();

    // const legalAdvicePage = useSelector((store) => store.data.legalAdvicePage);

    const { data: legalAdvicePageData, error, isLoading } = useGetLegalAdvicePageQuery();

    const [legalAdvicePage, setLegalAdvicePage] = useState(null);
    useEffect(() => {
        if (legalAdvicePageData) {

            setLegalAdvicePage({
                ...legalAdvicePageData,
                categories: legalAdvicePageData.categories.reduce((acc, category) => {
                    acc[category.id] = category;
                    return acc;
                }, {}),
                tags: legalAdvicePageData.tags
            });
        }
    }, [legalAdvicePageData]);


    return legalAdvicePage && (
        <section className="legal-advice">
            <Switch>
                <Route
                    exact path={routes.legal_advice}
                    render={(props) => <BaseRoute {...props} legalAdvicePage={legalAdvicePage} />}
                />
                
                <Route
                    exact path={routes.legal_advice + routes.legal_advice_routes.new_question}
                    render={(props) => <NewRoute oute {...props} legalAdvicePage={legalAdvicePage} />}
                />

                <Route
                    exact path={routes.legal_advice + routes.legal_advice_routes.view_question + '/:id'}
                    render={(props) => <QuestionRoute {...props} legalAdvicePage={legalAdvicePage} />}
                />

                <Route
                    exact path={routes.legal_advice + routes.legal_advice_routes.view_question + '/:id' + routes.legal_advice_routes.preview + '/:token'}
                    render={(props) => <QuestionRoute {...props} legalAdvicePage={legalAdvicePage} />}
                />

                <Route
                    exact path={routes.legal_advice + routes.legal_advice_routes.search_results + '/:query'}
                    render={(props) => <ResultsRoute {...props} legalAdvicePage={legalAdvicePage} />}
                />

                <Route
                    exact path={routes.legal_advice + "/:tag"}
                    render={(props) => <BaseRoute {...props} legalAdvicePage={legalAdvicePage} />}
                />

                <Route path="*">
                    <Redirect to={routes.legal_advice} />
                </Route>
            </Switch>
        </section>
    );
};

export default LegalAdvice;
